import * as yup from "yup";

export const schema = yup.object().shape({
  selectedEmails: yup
    .array()
    .min(1, "Please select at least one email address")
    .required("Please select at least one email address"),
  showCustomMessage: yup.boolean().required(),
  message: yup.string().when("showCustomMessage", {
    is: true,
    then: (schema) =>
      schema.trim().required("Required").max(400, "Message cannot exceed 400 characters"),
    otherwise: (schema) => schema.trim().default(""),
  }),
});
